import { ErrorDialog } from '@flippingbook/web.react-kit/dist/ErrorDialog';
import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import { Link } from '@flippingbook/web.react-kit/dist/Link';

import { InlineButton } from '@/components/InlineButton';
import { loc } from '@/localization';
import { discoveryService } from '@/services/instance/discovery';

import { b, e } from './style.css';

const siteUrl = discoveryService.get('site');
const HELP_LINK = `${siteUrl}/help/online/general/troubleshooting-guide#browser-error`;
const SUPPORT_LINK = `${siteUrl}/contacts?contact-form=support`;

function reloadPage() {
    window.location.reload();
}

function ReloadButton() {
    return (
        <InlineButton
            className={e.reloading}
            onClick={reloadPage}
        >
            {loc.Main.DangerDialogReloading}
        </InlineButton>
    );
}

function HelpCenter() {
    return (
        <span>
            <Link
                href={HELP_LINK}
                target="_blank"
            >
                {loc.Main.HelpCenter}
            </Link>
            <br />
        </span>
    );
}

function Support() {
    return (
        <span className={e.nowrapText}>
            <Link
                href={SUPPORT_LINK}
                target="_blank"
            >
                {loc.Main.Support}
            </Link>
            .
        </span>
    );
}

export function ErrorDisplay(props: ErrorDisplay.Props) {
    const { onClose } = props;

    return (
        <div className={b.name}>
            <ErrorDialog
                theme="red"
                onClose={onClose}
            >
                <p className={e.content}>
                    {loc.Main.DangerDialogOoops}
                    <br />
                    <L10n
                        text={loc.Main.DangerDialogPleaseTry}
                        replaces={[['{0}', <ReloadButton />]]}
                    />
                    <br />
                    <L10n
                        text={loc.Main.DangerDialogIfTheProblem}
                        replaces={[
                            ['{0}', <HelpCenter />],
                            ['{1}', <Support />],
                        ]}
                    />
                </p>
            </ErrorDialog>
        </div>
    );
}

export namespace ErrorDisplay {
    export interface Props {
        onClose: () => void;
    }
}
